import React, { useMemo } from 'react'

import { usePolls as usePollsData } from '../blocs/usePolls'
import type { RenderPollUnitWrapper } from '../model/Poll'

import { PollsList } from './PollsList'
import { type PollsContextValue, PollsProvider } from './PollsContext'

import './Polls.scss'

type PollsProps = {
  renderPollUnitWrapper?: RenderPollUnitWrapper
  isPublicPollOnly?: boolean
  isVotingAllowed?: boolean
  canChangePoll?: boolean
  disableOverlayTrigger?: boolean
}

export const Polls = ({
  renderPollUnitWrapper,
  isPublicPollOnly = false,
  isVotingAllowed = false,
  canChangePoll = false,
  disableOverlayTrigger = false,
}: PollsProps) => {
  const { polls, answeredPollIds, activatePoll, answerPoll } = usePollsData({
    publicOnly: isPublicPollOnly,
    isVotingAllowed,
  })

  const value = useMemo<PollsContextValue>(
    () => ({
      renderPollUnitWrapper,
      isVotingAllowed,
      canChangePoll,
      disableOverlayTrigger,
      activatePoll,
      answerPoll,
    }),
    [
      renderPollUnitWrapper,
      isVotingAllowed,
      canChangePoll,
      disableOverlayTrigger,
      activatePoll,
      answerPoll,
    ]
  )

  return (
    <div className="polls-component">
      <PollsProvider value={value}>
        <PollsList polls={polls} answeredPollIds={answeredPollIds} />
      </PollsProvider>
    </div>
  )
}
